// extracted by mini-css-extract-plugin
export default {"content":"c4tmz3","mobile":"G7ds5n","overriddenArrow":"Fmxoc7","mainBanner":"kXRfVE"};